<template>
  <div class="tw-pr-1 tw-bg-[#E1E1FF] tw-rounded-md">
    <select
      :id="id"
      v-model="modelValue"
      :name="name"
      class="
        tw-bg-[#E1E1FF]
        tw-text-[#4F4F4F]
        tw-rounded-md
        tw-px-2
        tw-py-[9px]
        tw-w-full
      "
    >
      <slot></slot>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      default: '',
      required: false,
      type: String,
    },
    name: {
      default: '',
      required: false,
      type: String,
    },
    value: {
      default: '',
      required: true,
      type: String,
    },
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style></style>
